<template>
  <v-app-bar app flat color="white">
    <v-app-bar-nav-icon @click.stop="setDrawer"></v-app-bar-nav-icon>

    <Breadcrumb />

    <v-spacer></v-spacer>
    <v-btn
      v-if="
        uiCtrl &&
        uiCtrl.isEnable('menu:::hardware_device') &&
        hardwares.length > 0
      "
      small
      depressed
      rounded
      class="mr-2"
      @click="handleClickButtonSyncDevice"
    >
      <v-icon small left color="primary">
        {{ hasDeviceSyncing ? 'mdi-autorenew' : 'mdi-check' }}
      </v-icon>
      <span class="text-none">
        {{
          hasDeviceSyncing
            ? 'กำลังซิงค์กับ Device'
            : 'ซิงค์กับ Device เสร็จสิ้น'
        }}
      </span>
    </v-btn>
    <v-menu offset-y max-width="280">
      <template v-slot:activator="{ on, attrs }">
        <v-btn rounded text color="grey darken-1" v-bind="attrs" v-on="on">
          <v-icon left>mdi-account</v-icon>
          <v-icon right>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list nav dense>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>Account</v-list-item-title>
            <v-list-item-subtitle>
              {{ user.email || user.fullName }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          link
          v-for="(menu, index) in accountMenus"
          :key="index"
          @click="onClickAccountMenu(menu.name)"
        >
          <v-list-item-icon>
            <v-icon v-text="menu.action"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ menu.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <DialogSyncDevice
      @onCloseDialogSyncDevice="handleCloseDialogSyncDevice"
      @onClickButtonSyncing="handleClickButtonSyncing"
      @onClickButtonSyncDone="handleClickButtonSyncDone"
      @onChangeSyncDeviceFilterStatus="handleChangeSyncDeviceFilterStatus"
      @onChangeSyncDeviceFilterHardware="handleChangeSyncDeviceFilterHardware"
      @onChangeItemsPerPageSyncDevice="handleChangeItemsPerPageSyncDevice"
    />
  </v-app-bar>
</template>

<script>
import { mapActions } from 'vuex'

import Breadcrumb from '@/components/Breadcrumb.vue'
import DialogSyncDevice from '@/components/DialogSyncDevice.vue'

export default {
  components: {
    Breadcrumb,
    DialogSyncDevice,
  },
  data() {
    return {
      syncDeviceTimerId: null,
      syncDeviceCancelSource: null,
      accountMenus: [
        {
          action: 'mdi-account-box',
          title: 'ข้อมูลส่วนตัว',
          name: 'profile',
        },
        {
          action: 'mdi-logout-variant',
          title: 'ออกจากระบบ',
          name: 'logout',
        },
      ],
    }
  },
  computed: {
    dialogSyncDevice() {
      return this.$store.state.hardware.dialogSyncDevice
    },
    responseSyncDevice() {
      return this.$store.state.hardware.responseSyncDevice
    },
    syncDeviceButtonType() {
      return this.$store.state.hardware.syncDeviceButtonType
    },
    hasDeviceSyncing() {
      return !!this.responseSyncDevice.length
    },
    isFetchingSyncDevice() {
      return this.$store.state.hardware.isFetchingSyncDevice
    },
    filterSyncDeviceStatus() {
      return this.$store.state.hardware.filterSyncDeviceStatus
    },
    filterSyncDeviceHardware() {
      return this.$store.state.hardware.filterSyncDeviceHardware
    },
    itemsPerPageSyncDevice() {
      return this.$store.state.hardware.itemsPerPageSyncDevice
    },
    selectedSyncDeviceHardware() {
      return this.$store.state.hardware.selectedSyncDeviceHardware
    },

    identifyModeAcu01r() {
      return this.$store.state.hardware.identifyModeAcu01r
    },
    identifyModeAcu81() {
      return this.$store.state.hardware.identifyModeAcu81
    },
    identifyModeCru77rf() {
      return this.$store.state.hardware.identifyModeCru77rf
    },
    identifyModeQ3rac() {
      return this.$store.state.hardware.identifyModeQ3rac
    },
    identifyModeTat51i() {
      return this.$store.state.hardware.identifyModeTat51i
    },
    identifyModeVf1000() {
      return this.$store.state.hardware.identifyModeVf1000
    },
    identifyModeVf1000r() {
      return this.$store.state.hardware.identifyModeVf1000r
    },
    identifyModeV600() {
      return this.$store.state.hardware.identifyModeV600
    },

    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    drawer() {
      return this.$store.state.drawer
    },
    company() {
      return this.$store.state.authentication.company || {}
    },
    user() {
      return this.$store.state.authentication.user || {}
    },
    hardwares() {
      return this.$store.state.hardware.hardwares
    },
  },
  watch: {
    company() {
      if (this.company) {
        this.fetchData()
      }
    },
    uiCtrl() {
      if (
        (this.uiCtrl && !this.uiCtrl.isEnable('menu:::hardware_device')) ||
        this.hardwares.length === 0
      ) {
        clearTimeout(this.syncDeviceTimerId)
      } else {
        this.restartPolling()
      }
    },
    selectedSyncDeviceHardware() {
      this.restartPolling()
    },
  },
  created() {
    if (this.company) {
      this.fetchData()
    }
  },
  methods: {
    ...mapActions({
      fetchIdentifyMode: 'hardware/fetchIdentifyMode',
      fetchHardwares: 'hardware/fetchHardwares',
      syncLogUnionSyncJob: 'hardware/syncLogUnionSyncJob',
      logout: 'authentication/logout',
    }),
    handleClickButtonSyncDevice() {
      this.$store.commit(
        'hardware/SET_SYNC_DEVICE_BUTTON_TYPE',
        this.hasDeviceSyncing ? 'syncing' : 'done'
      )
      this.$store.commit('hardware/SET_DIALOG_SYNC_DEVICE', true)
      this.restartPolling()
    },
    handleCloseDialogSyncDevice() {
      this.restartPolling()
    },
    handleClickButtonSyncing() {
      this.restartPolling()
    },
    handleClickButtonSyncDone() {
      this.restartPolling()
    },
    handleChangeSyncDeviceFilterStatus() {
      this.restartPolling()
    },
    handleChangeSyncDeviceFilterHardware() {
      this.restartPolling()
    },
    handleChangeItemsPerPageSyncDevice() {
      this.restartPolling()
    },
    async fetchDeviceData() {
      if (this.isFetchingSyncDevice) return
      this.$store.commit('hardware/SET_IS_FETCHING_SYNC_DEVICE', true)

      const controller = new AbortController()
      this.syncDeviceCancelSource = controller

      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payloadSyncDeviceButton = {
          params: {
            company_uuid,
            is_hardware_connected: true,
            is_done: false,
            is_cancel: false,
            limit: 1,
            offset: 0,
          },
          signal: controller.signal,
        }

        const payloadSyncDeviceTable = {
          params: {
            company_uuid,
            is_done: this.syncDeviceButtonType === 'done' ? true : false,
            is_hardware_connected:
              this.syncDeviceButtonType === 'syncing' ? true : undefined,
            is_success:
              this.filterSyncDeviceStatus &&
              this.syncDeviceButtonType === 'done'
                ? this.filterSyncDeviceStatus === 'success'
                  ? true
                  : false
                : undefined,
            hardware_uuid:
              this.selectedSyncDeviceHardware ||
              this.filterSyncDeviceHardware ||
              undefined,
            is_sync_request: this.selectedSyncDeviceHardware ? true : undefined,
            is_cancel: false,
            limit: this.itemsPerPageSyncDevice,
            offset: 0,
          },
          signal: controller.signal,
        }

        let payload = this.dialogSyncDevice
          ? payloadSyncDeviceTable
          : payloadSyncDeviceButton

        await this.syncLogUnionSyncJob(payload)
      } catch (error) {
        if (error.name === 'CanceledError') {
          // Request was cancelled, do nothing
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.commit('hardware/SET_IS_FETCHING_SYNC_DEVICE', false)
        this.scheduleNext()
      }
    },
    scheduleNext() {
      this.syncDeviceTimerId = setTimeout(this.fetchDeviceData, 1000 * 5) // 5 second;
    },
    restartPolling() {
      clearTimeout(this.syncDeviceTimerId)
      if (this.syncDeviceCancelSource) {
        this.syncDeviceCancelSource.abort()
      }
      this.fetchDeviceData()
    },
    setDrawer() {
      this.$store.commit('SET_DRAWER', !this.drawer)
    },
    onClickAccountMenu(name) {
      if (name === 'logout') {
        this.logout().then(() => {
          this.$store.commit('hardware/SET_HARDWARE_MODELS', [])
          this.$router.push({ path: '/?logout' })
        })
      } else if (name === 'profile') {
        this.$router.push({ name: 'Profile' })
      }
    },
    fetchData() {
      const { company_uuid } = this.$store.state.authentication.company || {}

      if (company_uuid) {
        const fetchHardwares = this.fetchHardwares({
          params: {
            company_uuid,
            dpc: 'hardware-to-list-hardware',
            limit: 1,
            offset: 0,
          },
        })

        this.$store.state.loading = true

        Promise.all([fetchHardwares])
          .then(() => {
            this.$store.state.loading = false
          })
          .catch((error) => {
            this.$store.state.loading = false
          })
      }
    },
  },
}
</script>
